(function() {
  'use strict';

  angular.module('app.organization', []);
})();
